import { Injectable } from '@angular/core';

export enum ThemeTypeEnum {
  dark = 'dark',
  teste = 'teste',
  default = 'default',
  light = 'light'
}

@Injectable({
  providedIn: 'root',
})
export class ThemeService {
  currentTheme = ThemeTypeEnum.dark;

  constructor() { }

  private reverseTheme(theme: string): ThemeTypeEnum {
    return theme === ThemeTypeEnum.dark ? ThemeTypeEnum.default : ThemeTypeEnum.dark;
  }

  private removeUnusedTheme(theme: ThemeTypeEnum): void {
    document.documentElement.classList.remove(theme);
    const removedThemeStyle = document.getElementById(theme);
    if (removedThemeStyle) {
      document.head.removeChild(removedThemeStyle);
    }
  }

  private loadCss(href: string, id: string): Promise<Event> {
    return new Promise((resolve, reject) => {
      const style = document.createElement('link');
      style.rel = 'stylesheet';
      style.href = href;
      style.id = id;
      style.onload = resolve;
      style.onerror = reject;
      document.head.append(style);
    });
  }

  public loadTheme(firstLoad = true): Promise<Event> {
    const theme = this.currentTheme;
    if (firstLoad) {
      document.documentElement.classList.add(theme);
    }
    return new Promise<Event>((resolve, reject) => {
      console.log(theme)

      this.loadCss(`${theme}.css`, theme).then(
        (e) => {
          if (!firstLoad) {
            document.documentElement.classList.add(theme);
          }
          this.removeUnusedTheme(this.reverseTheme(theme));
          resolve(e);
        },
        (e) => reject(e)
      );
    });
  }

  public toggleTheme(): Promise<Event> {
    this.currentTheme = this.reverseTheme(this.currentTheme);
    return this.loadTheme(false);
  }

  public toggleNewTheme(theme: ThemeTypeEnum): Promise<Event> {
    this.currentTheme = theme;
    return this.loadTheme(false);
  }
}
